import React from 'react';
import { VscTriangleUp } from "react-icons/vsc";
import { VscTriangleDown } from "react-icons/vsc";

import css from './ButtonsArrowsFilter.module.css';


const ButtonsArrowsFilter = ({onButtonUpClick,onButtonDownClick}) => {
    return (
        <div className={css.wrap}>
           <button onClick={onButtonUpClick}><VscTriangleUp /></button>

           <button onClick={onButtonDownClick}><VscTriangleDown /></button>
        </div>
    );
};

export {ButtonsArrowsFilter};